/**
 * Kleine datumhelpers voor de rustige projectpagina. Pure functies, geen tijdzoneschuif
 * bij pure datums ('YYYY-MM-DD' = lokale middernacht).
 */

export const MAANDEN = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
const DAGEN = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
export const DAG_MS = 24 * 60 * 60 * 1000;

/** 'YYYY-MM-DD…' of Date → lokale middernacht, of null. */
export function alsDag(waarde) {
  if (!waarde) return null;
  if (waarde instanceof Date) {
    return Number.isNaN(waarde.getTime()) ? null : new Date(waarde.getFullYear(), waarde.getMonth(), waarde.getDate());
  }
  const m = String(waarde).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m && !/T\d{2}:\d{2}.*(Z|[+-]\d{2}:?\d{2})$/.test(String(waarde))) {
    return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  }
  const d = new Date(waarde);
  return Number.isNaN(d.getTime()) ? null : new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

export function vandaagDag(vandaag) {
  return alsDag(vandaag instanceof Date ? vandaag : new Date());
}

/** Hele dagen van `vandaag` tot `dag` (negatief = verleden). */
export function dagenTot(dag, vandaag) {
  const d = alsDag(dag);
  if (!d) return null;
  return Math.round((d - vandaagDag(vandaag)) / DAG_MS);
}

/** "17 okt" (jaar erbij als het niet dit jaar is). */
export function korteDatum(dag, vandaag) {
  const d = alsDag(dag);
  if (!d) return '';
  const jaar = d.getFullYear() !== vandaagDag(vandaag).getFullYear() ? ` ${d.getFullYear()}` : '';
  return `${d.getDate()} ${MAANDEN[d.getMonth()]}${jaar}`;
}

/** "do 30 okt". */
export function dagEnDatum(dag, vandaag) {
  const d = alsDag(dag);
  if (!d) return '';
  return `${DAGEN[d.getDay()]} ${korteDatum(d, vandaag)}`;
}
